const dynamicCss = [
  '.flatpickr-calendar',
  '.open',
  '.inline',
  '.animate',
  '.static',
  '.multiMonth',
  '.flatpickr-days',
  '.flatpickr-day',
  '.dayContainer',
  '.inRange',
  '.hasWeeks ',
  '.hasTime',
  '.showTimeInput',
  '.flatpickr-time',
  '.rightMost',
  '.arrowTop',
  '.arrowBottom',
  '.flatpickr-wrapper',
  '.flatpickr-months',
  '.flatpickr-month',
  '.flatpickr-prev-month',
  '.flatpickr-next-month',
  '.numInputWrapper',
  '.arrowUp',
  '.arrowDown',
  '.flatpickr-current-month',
  '.cur-month',
  '.cur-year',
  '.flatpickr-monthDropdown-months',
  '.flatpickr-monthDropdown-month',
  '.flatpickr-weekdays',
  '.flatpickr-weekdaycontainer',
  '.flatpickr-weekday',
  '.dayContainer',
  '.flatpickr-weeks',
  '.dayContainer',
  '.prevMonthDay',
  '.nextMonthDay',
  '.today',
  '.selected',
  '.startRange',
  '.endRange',
  '.rangeMode',
  '.flatpickr-disabled',
  '.notAllowed',
  '.week',
  '.flatpickr-weekwrapper',
  '.flatpickr-innerContainer',
  '.flatpickr-rContainer',
  '.hasSeconds',
  '.time24hr',
  '.hidden',
  '.flatpickr-hour',
  '.flatpickr-minute',
  '.flatpickr-second',
  '.flatpickr-time-separator',
  '.flatpickr-am-pm',
  '.flatpickr-input',
];

export default (ctx, html) => {
  if (ctx.inline) {
    return html`<input>`;
  }

  return html`
  <slot>
    <div class="input-group">
      <input type="text" class="form-control form-control-sm">
      <div class="input-group-append">
        <span class="input-group-text">
          <span class="ai ai-calendar-sm"></span>
        </span>
      </div>
    </div>
  </slot>
  `;
};
